import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useMemo,
  useState
} from "react";

export interface UpdateInviteInfoObj {
  displayName?: string;
  reInviteMode?: boolean;
  disableSubmit?: boolean;
}

export interface IInviteFormContext {
  inviteInfoObj: UpdateInviteInfoObj;
  setInviteInfoObj: Dispatch<SetStateAction<UpdateInviteInfoObj>>;
}

export const defaultInviteContext = {
  inviteInfoObj: {
    disableSubmit: true
  },
  setInviteInfoObj: () => {}
};

export const InviteFormContext =
  createContext<IInviteFormContext>(defaultInviteContext);

export const InviteFormContextProvider = ({ children }) => {
  const [inviteInfoObj, setInviteInfoObj] = useState<UpdateInviteInfoObj>({});

  const value = useMemo(() => {
    return {
      inviteInfoObj,
      setInviteInfoObj
    };
  }, [inviteInfoObj]);

  return (
    <InviteFormContext.Provider value={value}>
      {children}
    </InviteFormContext.Provider>
  );
};

export const useInviteFormContext = () => useContext(InviteFormContext);
